import { Fragment } from "react"

import ModalChangEmail from "../ModalChangEmail/ModalChangEmail"
import OnboardingStepItem from "../OnboardingStepItem"
import StepSectionHeader from "../StepSectionHeader"
import useOnboardingStepsBlock from "./hooks/useOnboardingStepsBlock"

import "../../styles.less"

const OnboardingStepsBlock = () => {
  const {
    email,
    openModal,
    initStep,
    resendDeadline,
    totalSteps,
    totalSecondarySteps,
    preparedSteps,
    handleContinue,
    handleOpenModal,
    handleCloseModal,
    handleResend,
    verifyButtonState,
    completedPrimarySteps,
    completedSecondarySteps
  } = useOnboardingStepsBlock()

  return (
    <>
      <StepSectionHeader
        title="Verification"
        completed={completedPrimarySteps}
        total={totalSteps}
      />
      {preparedSteps.map((s) => (
        <Fragment key={s.step}>
          <OnboardingStepItem
            id={s.id}
            step={s.step}
            title={s.title}
            description={s.description}
            handleContinue={handleContinue}
            handleOpenModal={handleOpenModal}
            verifyButtonState={verifyButtonState}
            isVerify={s.isEdit}
            isEdit={s.isEdit}
            isDivider={s.isDivider}
            isComlete={s.isCompleted}
            isContinue={s.isContinue}
            isLocked={s.isLocked}
            lockedHint={s.lockedHint}
          />
          {s.id === 1 && (
            <StepSectionHeader
              title="Getting started"
              completed={completedSecondarySteps}
              total={totalSecondarySteps}
            />
          )}
        </Fragment>
      ))}
      <ModalChangEmail
        open={openModal}
        initStep={initStep}
        onClose={handleCloseModal}
        resendDeadline={resendDeadline}
        onResend={handleResend}
        currentEmail={email}
      />
    </>
  )
}

export default OnboardingStepsBlock
